import React from "react";
import styled from "styled-components";

const StyledRetranscriptionContainer = styled.div`
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
`;

const StyledMessageBubble = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.type === "user" ? "flex-end" : "flex-start"};
`;

const StyledBubble = styled.div`
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 15px;
  background-color: ${(props) => {
    if (props.type === "user") return "#007bff";
    if (props.type === "assistant") return "#6c757d";
    return "#28a745";
  }};
  color: white;
  word-wrap: break-word;
`;

const StyledTimestamp = styled.div`
  font-size: 11px;
  color: #999;
  margin-top: 5px;
  padding: 0 5px;
`;

const StyledEmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;
`;

const LeadAutoRetranscription = ({ retranscriptions = [] }) => {
  if (!retranscriptions || retranscriptions.length === 0) {
    return (
      <StyledEmptyState>
        <i className="fa fa-comment-o fa-3x mb-3" />
        <p>Aucune retranscription disponible</p>
      </StyledEmptyState>
    );
  }

  const parseRetranscription = (retranscription) => {
    const match = retranscription.match(/^(session|user|assistant):\s*(.*)$/);
    if (match) {
      return {
        type: match[1],
        content: match[2],
      };
    }
    return {
      type: "system",
      content: retranscription,
    };
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <StyledRetranscriptionContainer>
      {retranscriptions.map((item) => {
        const { type, content } = parseRetranscription(item.retranscription);

        if (type === "session") {
          return (
            <StyledMessageBubble key={item.id} type={type}>
              <StyledBubble type={type}>
                <small>
                  <i className="fa fa-info-circle mr-1" />
                  {content}
                </small>
              </StyledBubble>
              <StyledTimestamp>{formatDate(item.date)}</StyledTimestamp>
            </StyledMessageBubble>
          );
        }

        return (
          <StyledMessageBubble key={item.id} type={type}>
            <StyledBubble type={type}>{content}</StyledBubble>
            <StyledTimestamp>{formatDate(item.date)}</StyledTimestamp>
          </StyledMessageBubble>
        );
      })}
    </StyledRetranscriptionContainer>
  );
};

export default LeadAutoRetranscription;
